import FreeDownload from "@/pages/freeDownload";
import { FREE_DOWNLOAD_PATH } from "@/utils/base";

export default [
  {
    name: "FreeDownload",
    path: FREE_DOWNLOAD_PATH,
    component: <FreeDownload />,
  },
];
